import BlogUpdate from "../components/blog/blog-update";
import Layout from "../components/layout/layout";

const BlogUpdatePage = () => {
  return (
    <>
      <Layout>
        <div class="content">
          <div class="container">
            <div class="row">
              <BlogUpdate />
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default BlogUpdatePage;
